module.exports = __webpack_public_path__ + "media/images/dl-google-play-d84115285133e8d0f988f7dd258f954d.svg";